export enum NavigationStyle {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
